<form [formGroup]="form" (keydown.enter)="onEnter($event)">
  <div class="border-b p-1 bg-surface-quaternary">
    <soft-ds-progress-steps [steps]="steps()" [currentIndex]="navTabIndex()" />
  </div>

  <div class="p-4 flex flex-col overflow-hidden h-112">
    @if (navTabIndex() === 0) {
      <div class="w-full flex flex-col gap-3">
        <p class="text-xs font-semibold tracking-wide text-light uppercase px-1">
          {{ '#PMS_ROSTER.FORM.WHAT_TO_CREATE' | translate }}
        </p>

        <button
          type="button"
          class="group flex items-center gap-4 w-full rounded-xl border-2 bg-surface p-4 text-left transition-all cursor-pointer"
          [class]="
            eventType() === 'Planeintrag'
              ? 'border-primary shadow-sm'
              : 'border-transparent hover:border-outline hover:bg-hover'
          "
          (click)="eventType.set('Planeintrag'); this.navTabIndex.set(1)"
        >
          <div
            class="flex items-center justify-center size-12 rounded-xl shrink-0 transition-colors"
            [class]="
              eventType() === 'Planeintrag'
                ? 'bg-primary text-white'
                : 'bg-primary/10 text-primary'
            "
          >
            <i class="fa-regular fa-database text-xl"></i>
          </div>
          <div class="flex flex-col gap-0.5 flex-1 min-w-0">
            <p class="font-semibold text-base">
              {{ '#PMS_ROSTER.FORM.CREATE_PLAN_ENTRY' | translate }}
            </p>
            <p class="text-sm text-light">
              {{ '#PMS_ROSTER.FORM.PLAN_ENTRY_DESC' | translate }}
            </p>
          </div>
          <i
            class="text-xl shrink-0 transition-all"
            [class]="
              eventType() === 'Planeintrag'
                ? 'fa-solid fa-circle-check text-primary'
                : 'fa-regular fa-circle opacity-20'
            "
          ></i>
        </button>

        <button
          type="button"
          class="group flex items-center gap-4 w-full rounded-xl border-2 bg-surface p-4 text-left transition-all opacity-40 cursor-not-allowed"
          disabled
        >
          <div
            class="flex items-center justify-center size-12 rounded-xl shrink-0 bg-primary/10 text-primary"
          >
            <i class="fa-regular fa-calendar text-xl"></i>
          </div>
          <div class="flex flex-col gap-0.5 flex-1 min-w-0">
            <p class="font-semibold text-base">
              {{ '#PMS_ROSTER.FORM.CREATE_APPOINTMENT' | translate }}
            </p>
            <p class="text-sm text-light">
              {{ '#PMS_ROSTER.FORM.APPOINTMENT_DESC' | translate }}
            </p>
          </div>
          <i class="fa-regular fa-circle text-xl shrink-0 opacity-20"></i>
        </button>
      </div>
    }
    @if (navTabIndex() === 2) {
      <div>
        <div class="flex">
          <div class="flex flex-col w-full">
            <label class="soft-label top required" for="beginDay">
              {{ '#PMS_ROSTER.FORM.DATE' | translate }}
            </label>
            <soft-date-input
              [value]="date() ?? null"
              formControlName="beginDay"
              softFieldValidation
            />
          </div>
        </div>
        <div class="flex gap-2 pt-2">
          <div class="flex flex-col flex-1">
            <label class="soft-label top required" for="beginTime">
              {{ '#PMS_ROSTER.FORM.START_TIME' | translate }}
            </label>
            <soft-time-input
              class="rounded"
              formControlName="beginTime"
              softFieldValidation
            />
          </div>
          <div class="flex flex-col flex-1">
            <label class="soft-label top required" for="endTime">
              {{ '#PMS_ROSTER.FORM.END_TIME' | translate }}
            </label>
            <soft-time-input
              class="rounded"
              formControlName="endTime"
              softFieldValidation
            />
          </div>
        </div>
        <div class="flex gap-2 pt-2">
          <div class="flex flex-col flex-1">
            <p class="soft-label top">{{ '#PMS_ROSTER.FORM.DURATION' | translate }}</p>
            <div
              class="flex items-center h-8 px-3 border rounded bg-readonly text-sm text-light select-none"
            >
              {{ duration() ?? '—' }}
            </div>
          </div>
        </div>
      </div>
    }

    @if (navTabIndex() === 1) {
      <div class="flex flex-col gap-2 flex-1 overflow-hidden p-1">
        <!--p class="text-xs font-semibold tracking-wide text-light uppercase px-1">
          {{
            eventType() === 'Termin'
              ? ('#PMS_ROSTER.FORM.SELECT_PARTICIPANTS' | translate)
              : ('#PMS_ROSTER.FORM.SELECT_EMPLOYEE' | translate)
          }}
        </p-->

        <soft-input
          [icon]="'fa-regular fa-search'"
          type="text"
          [placeholder]="('#PMS_ROSTER.FORM.SEARCH_RESOURCES' | translate) ?? ''"
          [value]="employeeSearchQuery() ?? ''"
          (valueChange)="employeeSearchQuery.set($event)"
        />

        <div class="flex flex-col gap-1 flex-1 min-h-0 overflow-auto p-1">
          @for (employee of filteredResources(); track employee.id) {
            @if (eventType() === 'Termin') {
              <button
                type="button"
                class="flex items-center gap-3 w-full rounded-lg border-2 bg-surface px-3 py-2 text-left transition-all cursor-pointer shrink-0"
                [class]="
                  selectedParticipants()?.includes(employee.id + '')
                    ? 'border-primary shadow-sm'
                    : 'border-transparent hover:border-outline hover:bg-hover'
                "
                (click)="toggleParticipant(employee.id + '')"
              >
                <span class="flex-1 text-sm font-medium">
                  {{ resourceLabel(employee) }}
                </span>
                <i
                  class="text-base shrink-0 transition-all"
                  [class]="
                    selectedParticipants()?.includes(employee.id + '')
                      ? 'fa-solid fa-circle-check text-primary'
                      : 'fa-regular fa-circle opacity-20'
                  "
                ></i>
              </button>
            } @else {
              <button
                type="button"
                class="flex items-center gap-3 w-full rounded-lg border-2 bg-surface px-3 py-2 text-left transition-all cursor-pointer shrink-0"
                [class]="
                  form.value.employee === employee.id + ''
                    ? 'border-primary shadow-sm'
                    : 'border-transparent hover:border-outline hover:bg-hover'
                "
                (click)="selectEmployee(employee)"
              >
                <span class="flex-1 text-sm font-medium">
                  {{ resourceLabel(employee) }}
                </span>
                <i
                  class="text-base shrink-0 transition-all"
                  [class]="
                    form.value.employee === employee.id + ''
                      ? 'fa-solid fa-circle-check text-primary'
                      : 'fa-regular fa-circle opacity-20'
                  "
                ></i>
              </button>
            }
          }

          @if (eventType() === 'Termin' && foreignParticipants().length > 0) {
            <p
              class="text-xs font-semibold tracking-wide text-light uppercase px-1 pt-2 mt-1 border-t shrink-0"
            >
              {{ '#PMS_ROSTER.FORM.OTHER_DEPARTMENTS' | translate }}
            </p>
            @for (participant of foreignParticipants(); track participant.id) {
              <div
                class="flex items-center gap-3 w-full rounded-lg border-2 border-primary bg-surface px-3 py-2 shrink-0"
              >
                <span class="flex-1 text-sm font-medium">{{ participant.name }}</span>
                <soft-ds-icon class="text-primary" name="fa-solid fa-circle-check" />
              </div>
            }
          }
        </div>
      </div>
    }

    @if (navTabIndex() === 3) {
      <div
        class="grid grid-cols-2 gap-2 flex-1 min-h-0 overflow-y-auto content-start p-1"
      >
        @if (eventType() === 'Termin') {
          <div class="flex flex-col col-span-2">
            <label class="soft-label top required" for="title">
              {{ '#PMS_ROSTER.FORM.SUBJECT' | translate }}
            </label>
            <soft-input formControlName="title" softFieldValidation />
          </div>
        }
        <!--    @if (eventType() === 'Termin') {
        <div class="flex flex-col ml-2">
              <p class="checkbox-label" for="isPrivate">Privat</p>
              <div class="items-center flex justify-center content-center h-full">
                <soft-checkbox formControlName="isPrivate" />
              </div>
            </div>
      }-->
        @if (editMode()) {
          <div class="flex flex-col col-span-2">
            <label class="soft-label top" for="state">
              {{ '#PMS_ROSTER.FORM.STATUS' | translate }}
            </label>
            <soft-ds-select
              [value]="form.controls.state.value"
              (valueChange)="form.controls.state.setValue($event ?? 'UNDEFINED')"
            >
              @for (status of this.statuses(); track status.id) {
                <soft-ds-select-option [value]="status.id + ''" [label]="status.label" />
              }
            </soft-ds-select>
          </div>
        }
        <div class="flex flex-col col-span-2">
          <div class="flex items-center justify-between">
            <label class="soft-label top" for="comment">
              {{ '#PMS_ROSTER.FORM.DESCRIPTION' | translate }}
            </label>
            <soft-ds-button
              class="mb-1!"
              variant="ghost"
              size="sm"
              (click)="toggleCommentPreview()"
            >
              {{ commentPreviewVisible() ? 'Bearbeiten' : 'Markdown Vorschau' }}
              <ng-template softSlot="leading">
                <soft-ds-icon
                  [name]="
                    commentPreviewVisible()
                      ? 'fa-regular fa-pen-to-square'
                      : 'fa-regular fa-eye'
                  "
                />
              </ng-template>
            </soft-ds-button>
          </div>

          @if (commentPreviewVisible()) {
            <div
              class="comment-area markdown-preview border rounded bg-surface overflow-auto px-3 py-2"
            >
              @if (commentValue()?.trim()) {
                <markdown [data]="commentValue() ?? ''" />
              } @else {
                <p class="text-sm text-light italic">Keine Beschreibung</p>
              }
            </div>
          } @else {
            <soft-multiline-input
              class="comment-area"
              [lines]="'auto'"
              formControlName="comment"
              softFieldValidation
            />
          }
        </div>
        @if (eventType() === 'Planeintrag') {
          <div class="flex flex-col mt-1">
            <label class="soft-label top" for="ticket">
              {{ '#PMS_ROSTER.FORM.TICKET' | translate }}
            </label>
            <div
              class="flex items-center border-border border bg-surface gap-2 rounded"
              style="
                font-size: 0.875rem;
                line-height: 1.25rem;
                height: 2rem;
                padding-left: 0.75rem;
                padding-right: 0.75rem;
                padding-top: 1.7px;
                padding-bottom: 1.7px;
              "
              [class]="loading() ? 'bg-surface-tertiary' : ''"
            >
              @if (loading()) {
                <i class="fa-regular fa-spinner fa-spin"></i>
              }
              <input
                (keydown)="ticketSearchKeydown($event)"
                (paste)="ticketPaste($event)"
                (input)="ticketInputChange($event)"
                [placeholder]="('#PMS_ROSTER.FORM.TICKET_NUMBER' | translate) ?? ''"
                formControlName="ticket"
                softFieldValidation
              />

              @if (ticket() && !loading()) {
                <i
                  (click)="
                    ticket.set(undefined);
                    object.set(undefined);
                    ticketError.set(null);
                    form.controls.ticket.reset()
                  "
                  class="fa-regular fa-xmark cursor-pointer text-color"
                ></i>
              }
            </div>
          </div>

          <div class="flex flex-col">
            <soft-objekt-field-ok
              [value]="object()"
              (valueChange)="ticket.set(undefined); object.set($event)"
              [readonly]="this.ticket() !== undefined || !this.userCanViewObjects()"
              formControlName="object"
              softFieldValidation
            />
          </div>
        }
        @if (ticketError()) {
          <soft-validation-container
            class="mt-1 w-full col-span-2"
            [errors]="[{ kind: 'error', message: ticketError()! }]"
          />
        } @else if (ticket()) {
          <soft-validation-container
            class="mt-1 w-full col-span-2"
            [errors]="[
              {
                kind: 'success',
                message: 'Ticket gefunden: ' + ticket()!.id,
              },
            ]"
          />
        }
      </div>
    }
  </div>
</form>

<ng-template #bottomOutlet>
  <div class="w-full pt-2 flex flex-row justify-end gap-2">
    <button
      type="button"
      class="soft-button secondary h-10 rounded-md cursor-pointer"
      (click)="close()"
    >
      <div class="flex flex-row justify-center">
        {{ '#PMS_ROSTER.CANCEL' | translate }}
      </div>
    </button>
    @if (navTabIndex() === 0) {
      <button
        type="button"
        class="soft-button primary h-10 rounded-md text-white! cursor-pointer"
        [disabled]="!eventType()"
        (click)="this.navTabIndex.set(1)"
      >
        <div class="flex flex-row justify-center">
          {{ '#PMS_ROSTER.NEXT' | translate }}
          <soft-icon name="fa-regular fa-arrow-right" class="ml-2" />
        </div>
      </button>
    } @else if (navTabIndex() === 1) {
      <button
        type="button"
        class="soft-button primary h-10 rounded-md text-white! cursor-pointer"
        [disabled]="
          eventType() === 'Planeintrag'
            ? !form.value.employee
            : !selectedParticipants()?.length
        "
        (click)="this.navTabIndex.set(2)"
      >
        <div class="flex flex-row justify-center">
          {{ '#PMS_ROSTER.NEXT' | translate }}
          <soft-icon name="fa-regular fa-arrow-right" class="ml-2" />
        </div>
      </button>
    } @else if (navTabIndex() === 2) {
      <button
        type="button"
        class="soft-button primary h-10 rounded-md text-white! cursor-pointer"
        [disabled]="!form.value.beginDay || !form.value.beginTime || !form.value.endTime"
        (click)="this.navTabIndex.set(3)"
      >
        <div class="flex flex-row justify-center">
          {{ '#PMS_ROSTER.NEXT' | translate }}
          <soft-icon name="fa-regular fa-arrow-right" class="ml-2" />
        </div>
      </button>
    } @else if (navTabIndex() === 3) {
      <button
        type="button"
        class="soft-button primary h-10 rounded-md text-white! cursor-pointer"
        (click)="save()"
        [disabled]="!isFormValid() || !!ticketError()"
      >
        <div class="flex flex-row justify-center">
          <soft-icon name="fa-regular fa-floppy-disk" class="mr-2" />
          {{
            editMode()
              ? ('#PMS_ROSTER.SAVE' | translate)
              : ('#PMS_ROSTER.CREATE' | translate)
          }}
        </div>
      </button>
    }
  </div>
</ng-template>
